export default __webpack_public_path__ + "static/media/pptx.408555a6.png";